import { BaseRoute } from '@ridango/components';

export class RouteFilterUtil {
    /**
     * Toggle a route in the selected routes list
     * @param route The route to toggle
     * @param selectedRoutes Current selected routes
     * @returns Updated selected routes array
     */
    static toggleRoute(route: BaseRoute, selectedRoutes: BaseRoute[]): BaseRoute[] {
        const index = selectedRoutes.findIndex((r) => r.id === route.id);
        const updated = [...selectedRoutes];

        if (index < 0) {
            updated.push(route);
        } else {
            updated.splice(index, 1);
        }

        return updated;
    }

    /**
     * Check if a route is selected
     * @param route The route to check
     * @param selectedRoutes Current selected routes
     * @returns True if route is selected (or no filter applied)
     */
    static isRouteSelected(route: BaseRoute, selectedRoutes: BaseRoute[]): boolean {
        if (selectedRoutes.length === 0) {
            return true;
        }
        return selectedRoutes.some((r) => r.id === route.id);
    }

    /**
     * Get filtered route short names for emission
     * @param selectedRoutes Current selected routes
     * @param allRoutes All available routes
     * @returns Array of short names based on selection
     */
    static getFilteredShortNames(selectedRoutes: BaseRoute[], allRoutes: BaseRoute[]): string[] {
        if (selectedRoutes.length === 0 || selectedRoutes.length === allRoutes.length) {
            return allRoutes.map((r) => r.shortName);
        }
        return selectedRoutes.map((r) => r.shortName);
    }

    /**
     * Check if filter is actively filtering routes
     * @param selectedRoutes Current selected routes
     * @param allRoutes All available routes
     * @returns True if some but not all routes are selected
     */
    static isFilterActive(selectedRoutes: BaseRoute[], allRoutes: BaseRoute[]): boolean {
        return selectedRoutes.length > 0 && selectedRoutes.length !== allRoutes.length;
    }
}
